<template>
 <content-loader
    viewBox="0 0 1170 240"
    :speed="1"
    primaryColor="#f3f3f3"
    secondaryColor="#cfcfcf"
  >
    <rect x="0" y="44" rx="0" ry="0" width="90" height="20" /> 
    <rect x="125" y="44" rx="0" ry="0" width="1044" height="240" /> 
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
export default {
  components: {
    ContentLoader,
  },
};
</script>